// tslint:disable
/**
 * Projecto API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ScheduleEditCommandFromJSON(json) {
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'scheduleId': !exists(json, 'scheduleId') ? undefined : json['scheduleId'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'subprojectCode': !exists(json, 'subprojectCode') ? undefined : json['subprojectCode'],
        'phaseNum': !exists(json, 'phaseNum') ? undefined : json['phaseNum'],
        'phaseName': !exists(json, 'phaseName') ? undefined : json['phaseName'],
        'durationQuantity': !exists(json, 'durationQuantity') ? undefined : json['durationQuantity'],
        'durationUnitType': !exists(json, 'durationUnitType') ? undefined : json['durationUnitType'],
        'phaseStartInput': !exists(json, 'phaseStartInput') ? undefined : json['phaseStartInput'],
        'phaseFollows': !exists(json, 'phaseFollows') ? undefined : json['phaseFollows'],
        'phaseFollowsLeadLag': !exists(json, 'phaseFollowsLeadLag') ? undefined : json['phaseFollowsLeadLag'],
        'phaseEndInput': !exists(json, 'phaseEndInput') ? undefined : json['phaseEndInput'],
        'phaseComment': !exists(json, 'phaseComment') ? undefined : json['phaseComment'],
        'phasePctComplete': !exists(json, 'phasePctComplete') ? undefined : json['phasePctComplete'],
        'phaseStart': !exists(json, 'phaseStart') ? undefined : new Date(json['phaseStart']),
        'phaseEnd': !exists(json, 'phaseEnd') ? undefined : new Date(json['phaseEnd']),
        'baselineStart': !exists(json, 'baselineStart') ? undefined : new Date(json['baselineStart']),
        'baselineEnd': !exists(json, 'baselineEnd') ? undefined : new Date(json['baselineEnd']),
        'cPhaseType': !exists(json, 'cPhaseType') ? undefined : json['cPhaseType'],
        'cDurationDays': !exists(json, 'cDurationDays') ? undefined : json['cDurationDays'],
        'cPhaseLagDays': !exists(json, 'cPhaseLagDays') ? undefined : json['cPhaseLagDays'],
        'cTiedToCashflow': !exists(json, 'cTiedToCashflow') ? undefined : json['cTiedToCashflow'],
        'useChildrenDatesFlag': !exists(json, 'useChildrenDatesFlag') ? undefined : json['useChildrenDatesFlag'],
        'parentPhaseNum': !exists(json, 'parentPhaseNum') ? undefined : json['parentPhaseNum'],
        'rollupPhaseCode': !exists(json, 'rollupPhaseCode') ? undefined : json['rollupPhaseCode'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'createdDateTime': !exists(json, 'createdDateTime') ? undefined : new Date(json['createdDateTime']),
        'modifiedDateTime': !exists(json, 'modifiedDateTime') ? undefined : new Date(json['modifiedDateTime']),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
    };
}
export function ScheduleEditCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'scheduleId': value.scheduleId,
        'projectId': value.projectId,
        'subprojectCode': value.subprojectCode,
        'phaseNum': value.phaseNum,
        'phaseName': value.phaseName,
        'durationQuantity': value.durationQuantity,
        'durationUnitType': value.durationUnitType,
        'phaseStartInput': value.phaseStartInput,
        'phaseFollows': value.phaseFollows,
        'phaseFollowsLeadLag': value.phaseFollowsLeadLag,
        'phaseEndInput': value.phaseEndInput,
        'phaseComment': value.phaseComment,
        'phasePctComplete': value.phasePctComplete,
        'phaseStart': value.phaseStart === undefined ? undefined : value.phaseStart.toISOString(),
        'phaseEnd': value.phaseEnd === undefined ? undefined : value.phaseEnd.toISOString(),
        'baselineStart': value.baselineStart === undefined ? undefined : value.baselineStart.toISOString(),
        'baselineEnd': value.baselineEnd === undefined ? undefined : value.baselineEnd.toISOString(),
        'cPhaseType': value.cPhaseType,
        'cDurationDays': value.cDurationDays,
        'cPhaseLagDays': value.cPhaseLagDays,
        'cTiedToCashflow': value.cTiedToCashflow,
        'useChildrenDatesFlag': value.useChildrenDatesFlag,
        'parentPhaseNum': value.parentPhaseNum,
        'rollupPhaseCode': value.rollupPhaseCode,
        'createdBy': value.createdBy,
        'createdDateTime': value.createdDateTime === undefined ? undefined : value.createdDateTime.toISOString(),
        'modifiedDateTime': value.modifiedDateTime === undefined ? undefined : value.modifiedDateTime.toISOString(),
        'modifiedBy': value.modifiedBy,
    };
}
